





























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class QuestionBankTotalItem extends Vue {
  @Prop({ required: true })
  questionCount: number | null;

  @Prop({ required: true })
  currentQuestionCount: number | null;
}
